export const BUSINESS_MESSAGE = 'business message'
export const ACCEPTED = 'accepted'
export const CANCELLED = 'cancelled'
export const READY = 'ready'
export const COMPLETED = 'completed'

export default { BUSINESS_MESSAGE, ACCEPTED, CANCELLED, READY, COMPLETED }
